export default __webpack_public_path__ + "static/media/fallback.bdefbaec.png";